/*
 * @Author: Src
 * @Date: 2025-03-25 15:36:07
 * @LastEditTime: 2025-05-20 16:57:37
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/permissionRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import PermissionList from '@/views/permission/PermissionList.vue';
import OrganizationList from '@/views/permission/OrganizationList.vue';
import OrganizationDetail from '@/views/permission/OrganizationDetail.vue';
import { AuthEnum } from '@/services/permission.service';

const permissionRoutes: RouteConfig = {
  name: 'permission',
  path: '/permission',
  component: Main,
  redirect: {
    name: 'permission.list',
  },
  meta: {
    title: '权限管理',
  },
  children: [
    {
      name: 'permission.list',
      path: '/permission/list',
      component: PermissionList,
      props: {
        auth: [AuthEnum.权限列表],
      },
      meta: {
        title: '权限列表',
      },
    },
    {
      name: 'organization.list',
      path: '/permission/organization',
      component: OrganizationList,
      props: {
        auth: [AuthEnum.团队列表],
      },
      meta: {
        title: '团队列表',
      },
    },
    {
      name: 'organization.detail',
      path: '/permission/organization/detail/:id',
      component: OrganizationDetail,
      props: {
        auth: [AuthEnum.团队列表],
      },
      meta: { title: '团队详情' },
    },
  ],
};

export default permissionRoutes;
